<template>
  <lu-vbox class='signup-container app-container svpad-in-20' lu-flex>

   <Spinner ref='spinner' />

    <lu-vbox lu-flex v-if='!isValidateSignup'>
      <lu-hbox >
        <PageHeader title='Signup' >
          <lu-hbox slot='extraArea' class='pad-in-5'>
            <lu-item><el-button class="button" icon="el-icon-check"  @click.stop='submitCreateUser'>{{ $t('save') }}</el-button></lu-item>
            <lu-item><el-button class="button" icon="el-icon-close"  @click.stop='backToLogin'>{{ $t('cancel') }}</el-button></lu-item>
          </lu-hbox>
        </PageHeader>
      </lu-hbox>

      <lu-scroll-area lu-flex lu-flex-wrap class="mar-r-20" >

        <el-form ref='form' :model='form' :rules="rules" label-width="180px">

          <lu-vbox lu-flex lu-flex-wrap class='sectionBox'>
            <PageTitle :title='$t("Logo")' :expanded='logoExpanded' @toggleClose='toggleLogoClose' />

            <lu-hbox v-if='logoExpanded'>
              <el-form-item class='mar-l-10' prop='userLogo' style='max-width: 500px;' lu-flex-wrap >
                <el-upload
                  ref='uploadLogo'
                    :auto-upload="false"
                    action=""
                    v-model='form.userLogo'
                    list-type="picture-card"
                    :on-preview="handlePreviewLogo"
                    :on-remove="handleRemoveLogo"
                    :on-change="changeLogo"
                    :before-upload="beforeUploadLogo"
                    accept=" .jpg, .jpeg, .png"
                    :limit=1
                    >
                    <i class="el-icon-plus"></i>
                    <div class="el-upload__tip" slot="tip">{{ $t('jpg/png files with a size less than 500kb') }}</div>
                  </el-upload>

                    <el-dialog :visible.sync="logoVisible">
                      <img width="100%" :src="logoImageUrl" alt="">
                    </el-dialog>
              </el-form-item>

              <!-- <lu-item lu-vcenter lu-hcenter >
                <img :src="form.userLogo" style='margin: 0 0 40px 224px;width:148px; height: 148px; border-radius: 5px;'>
              </lu-item> -->

            </lu-hbox>
          </lu-vbox>


        <lu-vbox lu-vtop lu-flex lu-flex-wrap class='sectionBox'>
          <PageTitle :title='$t("Personal data")' :expanded='persoExpanded' @toggleClose='togglePersonClose' />

          <lu-hbox lu-flex lu-flex-wrap v-if='persoExpanded'>

            <el-form-item auto :label="$t('Login')" prop='login' >
              <el-input  :placeholder="form.login" type="text" clearable v-model='form.login' />
            </el-form-item>

            <el-form-item auto :label="$t('Password:')"  prop='password'  >
              <el-input placeholder="Please input password" v-model="form.password1"
                :key="password1Type"
                ref="password1"
                :type="password1Type"
                auto-complete="on"

              />
              <span class="show-pwd" @click="showPwd1">
                <svg-icon :icon-class="password1Type === 'password' ? 'eye' : 'eye-open'" />
              </span>
            </el-form-item>

            <el-form-item auto :label="$t('Confirm Password:')"  prop='password2' >
              <el-input placeholder="Please input password" v-model="form.password2"
                :key="password2Type"
                ref="password2"
                :type="password2Type"
                auto-complete="on"

              />
              <span class="show-pwd" @click="showPwd2">
                <svg-icon :icon-class="password2Type === 'password' ? 'eye' : 'eye-open'" />
              </span>

            </el-form-item>

            <el-form-item auto :label="$t('Gender')" prop='userGender'>
              <el-radio-group v-model="form.userGender">
                <el-radio v-for='item in optionsGender' :key='item.value' :label='item.value'>{{ item.label }}</el-radio>
              </el-radio-group>

            </el-form-item>

            <el-form-item auto :label="$t('First name')"  prop='userFirstName' >
              <el-input clearable v-model='form.userFirstName' />
            </el-form-item>

            <el-form-item auto :label="$t('Last name')"  prop='userLastName'>
              <el-input type="text" clearable v-model='form.userLastName' />
            </el-form-item>

            <el-form-item auto :label="$t('Date of birth')" prop='birthDate'>
              <el-date-picker id="date"
                v-model="form.birthDate"
                type="date"
                default-value="1975-01-01"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                >
              </el-date-picker>
            </el-form-item>

            <el-form-item auto :label="$t('Role')"  prop='roleId'>
              <el-select v-model="form.roleId" filterable clearable>
                <el-option v-for='item in roleList' :key="item.roleId" :label='item.label' :value='item.roleId'></el-option>
              </el-select>
            </el-form-item>
          </lu-hbox>
        </lu-vbox>


        <lu-vbox lu-vtop lu-flex lu-flex-wrap class='sectionBox'>
          <PageTitle :title='$t("Contact data")' :expanded='contactExpanded' @toggleClose='toggleContactClose'  />

          <lu-hbox lu-flex lu-flex-wrap v-if='contactExpanded'>
            <el-form-item  auto :label="$t('Street name')"  prop='addStreet'  >
              <el-input type="text" clearable v-model='form.addStreet' />
            </el-form-item>
            <el-form-item  auto :label="$t('Street Number')"  prop='addStreetNum'  >
              <el-input type="text" clearable v-model='form.addStreetNum' />
            </el-form-item>

            <el-form-item auto :label="$t('City')" prop='addCity'  >
              <el-input  type="text" clearable v-model='form.addCity'/>
            </el-form-item>
            <el-form-item auto :label="$t('Zip code')"  prop='addZipCode'  >
              <el-input type="text" clearable v-model='form.addZipCode'/>
            </el-form-item>

            <el-form-item auto :label="$t('Country')"  class='vpad-in-1' prop='codeCountry' >
              <el-select v-model="form.codeCountry" filterable clearable>
                <el-option v-for='item in countryList' :key='item.countryCode' :label='item.label' :value='item.countryCode'></el-option>
              </el-select>
            </el-form-item>

            <el-form-item auto :label="$t('State')"  prop='addState' :required='false'>
              <el-select v-model="form.addState" filterable clearable>
                <el-option v-for='item in stateList' :key="item.stateCode" :label='item.label' :value='item.stateCode'></el-option>
              </el-select>
            </el-form-item>

            <el-form-item auto :label="$t('Phone number')" prop='phoneNumber'  >
              <el-input type="text" clearable v-model='form.phoneNumber' />
            </el-form-item>

            <el-form-item auto :label="$t('Email address')" prop='userEmail'   >
              <el-input class="name"  clearable v-model='form.userEmail' type="text" />
            </el-form-item>

          </lu-hbox>
        </lu-vbox>

      </el-form>

      </lu-scroll-area>
    </lu-vbox>

    <ValidateSignup v-if='isValidateSignup' />
  </lu-vbox>
</template>

<script>
import { LuVbox, LuHbox, LuItem, LuScrollArea } from 'lusis-ui'
import Spinner from '@/components/Spinner'
import PageHeader from '@/components/PageHeader'
import PageTitle from '@/components/PageTitle'
import ValidateSignup from './validateSignup'
import messageHandler from '@/mixins/message'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'CreateAccount',
  mixins: [ messageHandler ],
  components: { LuVbox, LuItem, LuHbox, LuScrollArea, Spinner, PageHeader, PageTitle, ValidateSignup },
  props: [ ],
  data () {
    return {
      message: null,
      isSuccess: true,
      persoExpanded: true,
      contactExpanded: true,
      logoExpanded: true,
      logoImageUrl: '',
      logoVisible: false,
      countryList: [],
      roleList: [],
      isValidateSignup: false,
      password1Type: 'password',
      password2Type: 'password',
      form: {
        login: '',
        password1: null,
        password2: null,
        userGender: 1,
        userPhone: null,
        statusId: 5,
        userLogo: '',
        userEmail: '',
        userFirstName: '',
        userLastName: '',
        birthDate: null,
        addStreet: '',
        addStreetNum: '',
        addCity: '',
        addZipCode: '',
        addState: '',
        codeCountry: '',
        userTitle: '',
        roleId: ''
      },
      rules: {
        login: [
          { required: true, message: this.$t('Please input login'), trigger: ['blur', 'change'] },
          { min: 3, message: this.$t('Minimum length should be at least 3 characters.'), trigger: ['blur', 'change'] },
          { validator: this.validateUserLogin, message: this.$t('Login already exists') }
        ],
        userLastName: [
          { required: true, message: this.$t('Please input last name'), trigger: ['blur', 'change'] }
        ],
        userFirstName: [
          { required: true, message: this.$t('Please input first name'), trigger: ['blur', 'change'] },
          { min: 3, message: this.$t('Minimum length should be at least 3 characters.'), trigger: ['blur', 'change'] }
        ],
        birthDate: [
          { required: false, message: this.$t('Please input date of birth'), trigger: ['blur', 'change'] }
        ],
        password1: [
          { required: true, message: this.$t('Please input password'), trigger: ['blur', 'change'] },
          { min: 3, message: this.$t('Minimum length should be at least 8 characters.'), trigger: ['blur', 'change'] },
          { validator: this.validatePassword, message: this.$t('Passwords do not match') }
        ],
        password2: [
          { required: true, message: this.$t('Please input confirm password'), trigger: ['blur', 'change'] },
          { min: 3, message: this.$t('Minimum length should be at least 8 characters.'), trigger: ['blur', 'change'] },
          { validator: this.validateConfirmPassword, message: this.$t('Passwords do not match') }
        ],
        userEmail: [
          { required: true, message: 'Please input e-mail address', trigger: ['blur', 'change'] },
          { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] },
          { validator: this.validateUserEmail, message: this.$t('User Email already exists') }
        ],
        codeCountry: [
          { required: false, message: 'Please select country', trigger: 'change' }
        ],
        roleId: [
          { required: true, message: 'Please select role', trigger: 'change' }
        ],
        userPhone: [
          { required: false, message: 'Please input phone number', trigger: ['blur', 'change'] }
        ],
        userGender: [
          { required: false, message: 'Please select gender', trigger: 'change' }
        ],
        addStreet: [
          { required: false, message: this.$t('Please input street name'), trigger: ['blur', 'change'] }
        ],
        addStreetNum: [
          { required: false, message: this.$t('Please input street number'), trigger: ['blur', 'change'] }
        ],
        addCity: [
          { required: false, message: 'Please input city', trigger: ['blur', 'change'] }
        ],
        addZipCode: [
          { required: false, message: 'Please input zip code', trigger: 'blur' }
        ]
      },
      optionsGender: [{ value: 1, label: 'M' }, { value: 2, label: 'F' }]
    }
  },
  created () {
    if (!this.showRegister) {
      this.$router.push({path: '/login'})
    }
    //this.tango = null
    this.connectToServer().then(() => {
      //this.tango = server
      this.$tango.getCountryList().then(r => {
        this.countryList = r.countryList
      })
      this.$tango.searchUserRole().then(r => {
        this.roleList = r.roleList.filter(r => r.status === 1)
      })
    }).catch(() => {
      // eslint-disable-next-line handle-callback-err
      this.$message({
        type: 'error',
        message: this.$t('tango connection failed')
      })
    })
  },
  mounted () {
    this.$nextTick().then(() => this.autoCompleteOff())
  },
  updated () {
    this.$nextTick().then(() => this.autoCompleteOff())
  },
  watch: {
    'form.codeCountry': function (val) {
      if (!val) this.form.addState = ''
    }
  },
  computed: {
    ...mapState({ showRegister: state => state.tangoEnv.showRegister }),
    ...mapGetters('resultMessage', [ 'resultMessage' ]),
    stateList: function () {
      let idx = this.countryList.findIndex(c => c.countryCode === this.form.codeCountry)
      return idx !== -1 ? this.countryList[idx].stateList || [] : []
    }
  },
  methods: {
    toggleLogoClose: function () {
      this.logoExpanded = !this.logoExpanded
    },
    togglePersonClose: function () {
      this.persoExpanded = !this.persoExpanded
    },
    toggleContactClose: function () {
      this.contactExpanded = !this.contactExpanded
    },
    autoCompleteOff: function () {
      document.querySelectorAll('input[type=password]').forEach(f => {
        f.autocomplete = 'new-password'
      })
    },
    showPwd1() {
      this.password1Type = this.password1Type === 'password' ? '' : 'password'
      this.$nextTick(() => {
        this.$refs.password1.focus()
      })
    },
    showPwd2() {
      this.password2Type = this.password2Type === 'password' ? '' : 'password'
      this.$nextTick(() => {
        this.$refs.password2.focus()
      })
    },
    changeLogo (file) {
      if (!this.checkLogo(file)) return false
      let self = this
      let reader = new FileReader()
      reader.readAsDataURL(file.raw)
      reader.onload = function () {
        self.form.userLogo = this.result
      }
    },
    checkLogo (file) {
      const isExceedLogoSize = file.size / 1024 / 1024 < 0.5 // 500k
      if (!isExceedLogoSize) {
        this.form.userLogo = null
        this.$message.error(this.$t('The file size exceeds the limit allowed 500kb'))
        this.$refs.uploadLogo.clearFiles()
        return false
      }
      return true
    },
    handlePreviewLogo (file) {
      this.logoImageUrl = file.url
      this.logoVisible = true
    },
    handleRemoveLogo () {
      this.form.userLogo = null
    },
    beforeUploadLogo (file) {
      if (!this.checkLogo(file)) return false
    },
    submitCreateUser () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$refs.spinner.show()
          this.createUser()
        }
        else {
          this.$refs.spinner.hide()
        }
      })
    },
    resetForm () {
      this.$refs.form.resetFields()
    },
    createUser () {
      let cond = {
        login: this.form.login,
        password: this.form.password1,
        userPhone: this.form.userPhone,
        statusId: 5,
        userLogo: this.form.userLogo,
        userEmail: this.form.userEmail,
        userGender: this.form.userGender,
        userFirstName: this.form.userFirstName,
        userLastName: this.form.userLastName,
        birthDate: this.form.birthDate,
        addStreet: this.form.addStreet,
        addStreetNum: this.form.addStreetNum,
        addCity: this.form.addCity,
        addZipCode: this.form.addZipCode,
        addState: this.form.addState,
        codeCountry: this.form.codeCountry,
        userTitle: this.form.userTitle,
        userId: this.form.userId,
        roleId: this.form.roleId
      }
      let api = this.form.userId ? 'signUpdateUser' : 'createAccount'

      //this.connectToServer().then(server => server[api](cond)).then(rep => {
      this.connectToServer().then(() => this.$tango[api](cond)).then(rep => {
        if (rep.resultCode === 0) {
          this.$refs.spinner.hide()
          this.showMessage(this.$t('Creation user has been successfully completed', true))
          this.isValidateSignup = true
          /*
          setTimeout(() => {
            let params = Object.assign({}, this.$route.params)
            params.email = this.form.userEmail
            params.redirectRoute = this.$route.redirectedFrom
            // eslint-disable-next-line handle-callback-err
            this.$router.push({ name: 'validateSignup', params: params }).catch(err => {})
            // this.$router.push({ name: 'validateSignup', params: { email: this.form.userEmail, redirectRoute: this.$route.redirectedFrom || '' } })
          }, 2000)
          */
        }
        else {
          throw new Error(this.$t(this.resultMessage[rep.resultCode]))
        }
      }).catch(err => {
        // eslint-disable-next-line handle-callback-err
        this.$message({
          type: 'error',
          message: err.message
        })
        this.$refs.spinner.hide()
      })
    },
    setErrorField (fieldName, msg) {
      this.$refs.spinner.hide()
      return this.$refs.form.fields.filter(p => {
        if (typeof p.prop !== 'undefined' && p.prop === fieldName) {
          this.showMessage(msg, false)
          p.validateState = 'error'
          p.$children[0].focus()
          return false
        }
      }).map(p => p)
    },
    validatePassword (rule, value, cb) {
      if (this.form.password2 !== '') {
        this.$refs.form.validateField('password2')
      }
      cb()
    },
    validateUserLogin (rule, value, cb) {
      let cond = [{'field name': 'login', 'operator': '=', 'value': [ value ]}]
      return this.$tango.searchUser({conditions: cond}).then(rep => {
        if (rep.resultCode === 0) {
          cb(!rep.totalCount ? undefined : new Error())
        }
        else cb(new Error())
      })
    },
    validateUserEmail (rule, value, cb) {
      let cond = [{'field name': 'userEmail', 'operator': '=', 'value': [ value ]}]
      return this.$tango.searchUser({conditions: cond}).then(rep => {
        if (rep.resultCode === 0) {
          cb(!rep.totalCount ? undefined : new Error())
        }
        else cb(new Error())
      })
    },
    validateConfirmPassword (rule, value, cb) {
      if (value === '') {
        cb(new Error('Please input the password again'))
      }
      else if (value !== this.form.password1) {
        cb(new Error('Passwords does not match!'))
      }
      else {
        cb()
      }
    },
    backToLogin () {
      // eslint-disable-next-line handle-callback-err
      this.$router.push('/login').catch(() => {})
    },
    showMessage: function (msg, isSuccess) {
      this.message = msg
      this.isSuccess = isSuccess
    }
  }
}
</script>

<style lang="scss">
.signup-container {

  .show-pwd {
    position: absolute;
    right: 0px;
    font-size: 1.2em;
    cursor: pointer;
    user-select: none;
  }
}

</style>
